import React, { useEffect, useState } from "react";
import TextFieldCustom from "../../../../component/elements/textfieldCustom";
import CustomButton from "../../../../component/elements/CustomButton/CustomButton";
import { validateForm } from "../../../../utils/formValidation/validation";
import { otherDetailsRules } from "../../../../utils/formValidation/validationRules";
import axiosInstance from "../../../../configuration/request";
import {
    buildPersonalInfoPayload,
    buildOtherDetailsPayload,
} from "../../../../utils/buildUserPayload";
import { useSnackbar } from "../../../../component/SnackbarContext";
import { useDispatch, useSelector } from "react-redux";
import { editUser } from "../../../../utils/updateUser";
import { clearAll, setApprovalDetails, setLoginDetails } from "../../../../Redux/Slices/counterSlice";
import { useNavigate } from "react-router-dom";
import BackButton from "../../../../component/backButton";
import UploadDoc from "../../../../component/uploadDoc";

const documents = [
    {
        heading: "Upload driving license",
        documentType: "PDF, JPEG or JPG",
        name: "driving_license",
    },
    {
        heading: "Upload Insurance (if any)",
        documentType: "PDF, JPEG or JPG",
        name: "insurance",
    },
];

const VehicalDetails = () => {
    const [formData, setFormData] = useState({
        vechicalType: "",
        licencePlateNumber: "",
    });

    const [formErrors, setFormErrors] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [missingDocs, setMissingDocs] = useState([]);
    const requiredDocs = ["driving_license", "insurance"];
    const showSnackbar = useSnackbar();
    const { personalDetails } = useSelector((state) => state.counter);
    const { authDetails } = useSelector((state) => state.counter);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        if (!authDetails?.otpVerified) {
            navigate("/auth/account");
        }
    }, []);

    const handleChange = (field) => (e) => {
        const value = e.target?.value ?? e;
        setFormData((prev) => ({ ...prev, [field]: value }));
        setFormErrors((prev) => ({ ...prev, [field]: "" }));
    };

    const handleSubmit = async () => {
        const errors = validateForm(formData, otherDetailsRules);
        setFormErrors(errors);
        const uploadedNames = uploadedFiles.map((file) => file.name);
        const missing = requiredDocs.filter((doc) => !uploadedNames.includes(doc));
        setMissingDocs(missing);
        if (Object.keys(errors).length === 0 && missing.length <= 0) {
            let payloadData = {
                ...buildPersonalInfoPayload(personalDetails),
                ...buildOtherDetailsPayload({
                    otherDetails: formData,
                    uploadedDocs: formData.documents,
                }),
            };
            const res = await editUser(payloadData, authDetails.userId, showSnackbar);
            payloadData.userType = res?.data?.userType;
            dispatch(setApprovalDetails(payloadData));
            dispatch(setLoginDetails(authDetails));
            dispatch(clearAll());
            navigate(`/auth/approval`);
        }
    };

    const handleFileSelect = async (file, file_name) => {
        try {
            const formData = new FormData();
            formData.append("file", file);
            const response = await axiosInstance.post(
                "/customer/upload/file",
                formData
            );
            const fileUrl = response.data?.url || "";
            setUploadedFiles((prev) => {
                const others = prev.filter((doc) => doc.name !== file_name);
                return [...others, { name: file_name, fileUrl }];
            });
            setMissingDocs((prev) => prev.filter((doc) => doc !== file_name));
        } catch (error) {
            console.error("Upload failed:", error);
        }
    };

    return (
        <div className="w-full h-[calc(100vh-85px)] overflow-y-auto">
            <div className="flex flex-col items-center w-full max-w-2xl mx-auto bg-white rounded-2xl py-4">
                <div className="w-full max-w-4xl px-8 mt-3  flex items-center">
                    <BackButton onClick={() => navigate("/auth/register")} />
                </div>
                <div className="text-2xl font-semibold mb-1 ">
                    Register Your account
                </div>
                <div className="text-sm mb-4">Enter your details to Register</div>

                <div className="w-full max-w-4xl space-y-4 px-8 mt-6">
                    {/* Section: Basic Details */}
                    <div>
                        <div className="text-sm font-semibold text-gray-700 mb-3">
                            Vehical Details
                        </div>
                        <div className=" grid gap-3 grid-cols-1 sm:grid-cols-2">
                            <TextFieldCustom
                                label="Vehicle type*"
                                fullWidth
                                value={formData.vechicalType}
                                onChange={handleChange("vechicalType")}
                                error={!!formErrors.vechicalType}
                                helperText={formErrors.vechicalType || " "}
                            />
                            <TextFieldCustom
                                label="License Plate Number*"
                                fullWidth
                                value={formData.licencePlateNumber}
                                onChange={handleChange("licencePlateNumber")}
                                error={!!formErrors.licencePlateNumber}
                                helperText={formErrors.licencePlateNumber || " "}
                            />
                        </div>
                    </div>

                    {/* Section: Address */}
                    <div>
                        <div className="text-sm font-semibold text-gray-700 mb-3">
                            Upload Documents
                        </div>
                        <div className="flex gap-3  flex-wrap">
                            {documents.map((doc, idx) => {
                                const uploadedDoc = uploadedFiles.find(
                                    (f) => f.name === doc.name
                                );
                                const hasError = missingDocs.includes(doc.name);
                                return (
                                    <div key={idx} className="flex flex-col">
                                        <UploadDoc
                                            doc_name={doc.name}
                                            heading={doc.heading}
                                            documentType={doc.documentType}
                                            onFileSelect={handleFileSelect}
                                            fileUploaded={!!uploadedDoc}
                                            fileUrl={uploadedDoc?.fileUrl}
                                            hasError={hasError}
                                        />
                                        {hasError && (
                                            <span className="text-xs text-[#d32f2f] mt-1 ml-1">
                                                {doc.name} is required.
                                            </span>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className="flex justify-center pt-4 pb-6">
                        <CustomButton
                            onClick={handleSubmit}
                            customeClass="auth-button w-[300px] h-[45px]"
                        >
                            Submit
                        </CustomButton>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default VehicalDetails;
